import { handler, HandlerBody } from ".";
import { ApplicationSetting, Dirty, EMPTY_GUID, Identifier } from "../model";

function optionsHandlerRaw(body: HandlerBody, ucStatus = true) {
  return handler('/Handlers/Dialogs/OptionsHandler.ashx', body, ucStatus)
}

/*
async function optionHandler<T = any>(body: HandlerBody, ucStatus = true) {
  return parseJson<T>(await optionsHandlerRaw(body, ucStatus))
}
*/


export async function saveInstantMessageSettings(extension: Identifier, imEnabled?: boolean, imAllowBlockedMessagesSentAsEmails?: boolean, imBlockMessageInLocation?: boolean) {
  const data = [imEnabled === undefined ? null : imEnabled ? 'true' : 'false', imBlockMessageInLocation === undefined ? null : imBlockMessageInLocation ? 'true' : 'false', imAllowBlockedMessagesSentAsEmails === undefined ? null : imAllowBlockedMessagesSentAsEmails ? 'true' : 'false']
  await optionsHandlerRaw({ command: 'save', servername: extension.server, extensionId: extension.id, data2: JSON.stringify(data) }, false)
}

export async function saveApplicationSettings(extension: Identifier, setting: ApplicationSetting) {
  if (EMPTY_GUID === setting.applicationSettingId) {
    setting = { ...setting, applicationSettingId: createGuid(), dirty: Dirty.Insert }
  } else {
    setting = { ...setting, dirty: Dirty.Edit }
  }

  await optionsHandlerRaw({ command: 'save', servername: extension.server, extensionId: extension.id, data1: JSON.stringify(setting) }, false)
  return setting as ApplicationSetting
}


function createGuid() {
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
    let r = Math.random() * 16 | 0, v = c === 'x' ? r : (r & 0x3 | 0x8);
    return v.toString(16);
  });
}
